import RenderMeasurementsInsideShape from "./renderMeasurementsInsideShape";
import workspace from "../../workspace";
import sqftConfig from "../../../store/sqftConfig";
import {getPointField} from "../../../../../helpers/sqftHelper";
import RenderFigures from "../../../helpers/renderFigures";
import RenderSVG from "./renderSVG";

class RenderMovableImage {
  constructor(movableImage) {
    this.movableImage = movableImage;
    this.renderMeasurementsInsideShape = new RenderMeasurementsInsideShape(movableImage);
    this.renderSVG = new RenderSVG(movableImage);
  }

  destroy = () => {
    //this.renderMeasurementsInsideShape.destroy();
  }

  setOuterShape = (value) => {
    this.renderMeasurementsInsideShape.outerShape = value
  }

  render = (ctx) => {
    if (workspace && workspace.getState().loading) return;
    if (this.movableImage.getIsRotatable()) {
      this.movableImage.shapeRotatable.render(ctx);
    }

    if (this.movableImage.attachedTo) {
      //this.renderSVG.renderAttachedTo(ctx);
    } else {
      this.renderSVG.render(ctx);

      //render measurements inside the shape
      const outerShape = this.movableImage.getOuterShape();
      if (this.movableImage.shouldRenderMeasurementsInsideTheShape() && outerShape) {
        this.movableImage.revealMeasurementsInsideShape();
        this.setOuterShape(outerShape);
        this.renderMeasurementsInsideShape.render(ctx);
      } else {
        this.movableImage.hideMeasurementsInsideShape();
      }
    }

    //render in dev mode
    if (sqftConfig.isDevMode()) {

      //render lines
      this.movableImage.getLines().forEach((activeShapeLine) => {
        let pointFieldActiveShapeLineFrom = getPointField(activeShapeLine.from.x, activeShapeLine.from.y, this.movableImage);
        RenderFigures.renderCircle(pointFieldActiveShapeLineFrom, 5, 1, '#63b141');
      });

      //render position
      RenderFigures.renderCircle(this.movableImage.getPosField(), 15, 1, '#b1417f');
    }
    return []; //no triangles for images
  }
}

export default RenderMovableImage
